import { IndexedDataPhoto } from '../types/Modified';
import { SmpDataPhoto } from '../types/SmpData';

export const getOrderedList = (photos: (SmpDataPhoto | IndexedDataPhoto)[]): (SmpDataPhoto | IndexedDataPhoto)[] => {
  const unlocked = photos.filter(photo => !photo.blurred);
  const locked = photos.filter(photo => photo.blurred);
  return [...unlocked, ...locked];
};
